import { t } from "@/lib/i18n"

/**
 * Formats a date string as a relative time in Spanish.
 * Examples: "ahora", "hace 5 min", "hace 2 h", "ayer", "hace 3 días"
 */
export function formatRelativeTime(dateStr: string): string {
  const now = new Date()
  const date = new Date(dateStr)
  const diffMs = now.getTime() - date.getTime()
  const diffMin = Math.floor(diffMs / 60000)
  const diffH = Math.floor(diffMin / 60)
  const diffDays = Math.floor(diffH / 24)

  if (diffMin < 1) return t.time.now
  if (diffMin < 60) return t.time.minutesAgo(diffMin)
  if (diffH < 24) return t.time.hoursAgo(diffH)
  if (diffDays === 1) return t.time.yesterday
  if (diffDays < 7) return t.time.daysAgo(diffDays)
  return date.toLocaleDateString("es-AR", { day: "numeric", month: "short" })
}
